import { render } from "./QR_READ.vue?vue&type=template&id=ce2aef76"
import script from "./QR_READ.vue?vue&type=script&lang=js"
export * from "./QR_READ.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-kiosk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__